"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    cursor: prop_types_1.default.string,
    pointerEvents: prop_types_1.default.string,
    userSelect: prop_types_1.default.string,
    visibility: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const cursor = {
    className: 'crsr',
    cssName: 'cursor',
    jsName: 'cursor'
};
const userSelect = {
    className: 'usr-slct',
    cssName: 'user-select',
    jsName: 'userSelect',
    safeValue: true,
    isPrefixed: true
};
const visibility = {
    className: 'vsblt',
    cssName: 'visibility',
    jsName: 'visibility',
    safeValue: true
};
const pointerEvents = {
    className: 'ptr-evts',
    cssName: 'pointer-events',
    jsName: 'pointerEvents',
    safeValue: true
};
exports.propEnhancers = {
    cursor: (value) => get_css_1.default(cursor, value),
    pointerEvents: (value) => get_css_1.default(pointerEvents, value),
    userSelect: (value) => get_css_1.default(userSelect, value),
    visibility: (value) => get_css_1.default(visibility, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJhY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW5oYW5jZXJzL2ludGVyYWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsNERBQWtDO0FBQ2xDLHlEQUErQjtBQUdsQixRQUFBLFNBQVMsR0FBcUI7SUFDekMsTUFBTSxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUN4QixhQUFhLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQy9CLFVBQVUsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDNUIsVUFBVSxFQUFFLG9CQUFTLENBQUMsTUFBTTtDQUM3QixDQUFBO0FBRVksUUFBQSxXQUFXLEdBQWdCLEVBQUUsQ0FBQTtBQUU3QixRQUFBLGNBQWMsR0FBbUIsRUFBRSxDQUFBO0FBRWhELE1BQU0sTUFBTSxHQUFHO0lBQ2IsU0FBUyxFQUFFLE1BQU07SUFDakIsT0FBTyxFQUFFLFFBQVE7SUFDakIsTUFBTSxFQUFFLFFBQVE7Q0FDakIsQ0FBQTtBQUNELE1BQU0sVUFBVSxHQUFHO0lBQ2pCLFNBQVMsRUFBRSxVQUFVO0lBQ3JCLE9BQU8sRUFBRSxhQUFhO0lBQ3RCLE1BQU0sRUFBRSxZQUFZO0lBQ3BCLFNBQVMsRUFBRSxJQUFJO0lBQ2YsVUFBVSxFQUFFLElBQUk7Q0FDakIsQ0FBQTtBQUNELE1BQU0sVUFBVSxHQUFHO0lBQ2pCLFNBQVMsRUFBRSxPQUFPO0lBQ2xCLE9BQU8sRUFBRSxZQUFZO0lBQ3JCLE1BQU0sRUFBRSxZQUFZO0lBQ3BCLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUE7QUFDRCxNQUFNLGFBQWEsR0FBRztJQUNwQixTQUFTLEVBQUUsVUFBVTtJQUNyQixPQUFPLEVBQUUsZ0JBQWdCO0lBQ3pCLE1BQU0sRUFBRSxlQUFlO0lBQ3ZCLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBa0I7SUFDMUMsTUFBTSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDO0lBQy9ELGFBQWEsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsYUFBYSxFQUFFLEtBQUssQ0FBQztJQUM3RSxVQUFVLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLFVBQVUsRUFBRSxLQUFLLENBQUM7SUFDdkUsVUFBVSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxVQUFVLEVBQUUsS0FBSyxDQUFDO0NBQ3hFLENBQUEifQ==